export const DOCTOR_AVAILABILITIES_CLEAR                  = 'DOCTOR_AVAILABILITIES_CLEAR';

export const DOCTOR_AVAILABILITIES_CREATE                 = 'DOCTOR_AVAILABILITIES_CREATE';
export const DOCTOR_AVAILABILITIES_CREATE_DONE            = 'DOCTOR_AVAILABILITIES_CREATE_DONE';

export const DOCTOR_AVAILABILITIES_DELETE                 = 'DOCTOR_AVAILABILITIES_DELETE';
export const DOCTOR_AVAILABILITIES_DELETE_DONE            = 'DOCTOR_AVAILABILITIES_DELETE_DONE';

export const DOCTOR_AVAILABILITIES_FETCH                  = 'DOCTOR_AVAILABILITIES_FETCH';
export const DOCTOR_AVAILABILITIES_FETCH_DONE             = 'DOCTOR_AVAILABILITIES_FETCH_DONE';

export const DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE       = 'DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE';
export const DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE_DONE  = 'DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE_DONE';

export const DOCTOR_CREATE                                = 'DOCTOR_CREATE';
export const DOCTOR_CREATE_DONE                           = 'DOCTOR_CREATE_DONE';

export const DOCTOR_EDIT                                  = 'DOCTOR_EDIT';
export const DOCTOR_EDIT_DONE                             = 'DOCTOR_EDIT_DONE';

export const DOCTOR_DELETE                                = 'DOCTOR_DELETE';
export const DOCTOR_DELETE_DONE                           = 'DOCTOR_DELETE_DONE';

export const DOCTOR_LIST_FETCH                            = 'DOCTOR_LIST_FETCH';
export const DOCTOR_LIST_FETCH_DONE                       = 'DOCTOR_LIST_FETCH_DONE';

export const DOCTOR_LIST_FETCH_FOR_OFFICE                 = 'DOCTOR_LIST_FETCH_FOR_OFFICE';
export const DOCTOR_LIST_FETCH_FOR_OFFICE_DONE            = 'DOCTOR_LIST_FETCH_FOR_OFFICE_DONE';



// WEBPACK FOOTER //
// ./app/constants/doctorTypes.js